import { routePermissions } from "@/constants/permission-user"

export const routesModule3 = [
  {
    path: "/backup-management/dashboard",
    name: "backupManagementDashboard",
    component: () => import("@/views/backupManagement/Dashboard.vue"),
    meta: {
      pageTitle: "Dashboard",
      breadcrumb: [
        {
          text: "Dashboard",
          active: true,
        },
      ],
    },
  },
  {
    path: "/backup-management/server-management",
    name: "backupManagementServerManagement",
    component: () => import("@/views/backupManagement/ServerManagement.vue"),
    meta: {
      pageTitle: "Server Management",
      breadcrumb: [
        {
          text: "Server Management",
          active: true,
        },
      ],
    },
  },
  {
    path: "/backup-management/repository",
    name: "backupManagementRepository",
    component: () => import("@/views/backupManagement/Repository.vue"),
    meta: {
      pageTitle: "Repository Management",
      breadcrumb: [
        {
          text: "Repository Management",
          active: true,
        },
      ],
    },
  },
  {
    path: "/backup-management/backup",
    name: "backupManagementBackup",
    component: () => import("@/views/backupManagement/BackupManagement.vue"),
    meta: {
      pageTitle: "Backup Management",
      breadcrumb: [
        {
          text: "Backup Management",
          active: true,
        },
      ],
    },
  },
  {
    path: "/backup-management/backup/create",
    name: "backupManagementCreateNewBackup",
    component: () =>
      import("@/views/backupManagement/backup/CreateEditBackup.vue"),
    meta: {
      pageTitle: "Backup Management",
      breadcrumb: [
        {
          text: "Backup Management",
          active: false,
          to: "/backup-management/backup",
        },
        {
          text: "Create Backup",
          active: true,
        },
      ],
      navActiveLink: "backupManagementBackup",
    },
  },
  {
    path: "/backup-management/backup/detail/:id",
    name: "backupManagementDetailBackup",
    component: () =>
      import("@/views/backupManagement/backup/CreateEditBackup.vue"),
    meta: {
      pageTitle: "Backup Management",
      breadcrumb: [
        {
          text: "Backup Management",
          active: false,
          to: "/backup-management/backup",
        },
        {
          text: "Backup Detail",
          active: true,
        },
      ],
      navActiveLink: "backupManagementBackup",
    },
  },
  {
    path: "/backup-management/credential",
    name: "backupManagementCredential",
    component: () => import("@/views/backupManagement/Credential.vue"),
    meta: {
      pageTitle: "Credential Management",
      breadcrumb: [
        {
          text: "Credential Management",
          active: true,
        },
      ],
    },
  },
  {
    path: "/backup-management/veeam",
    name: "backupManagementVeeam",
    component: () => import("@/views/backupManagement/VeeamManagement.vue"),
    meta: {
      pageTitle: "Veeam Management",
      breadcrumb: [
        {
          text: "Veeam Management",
          active: true,
        },
      ],
    },
  },
].map((route) => {
  return {
    ...route,
    meta: {
      ...route.meta,
      module: "backupManagement",
      type: "internal",
      permission: routePermissions[route.name],
    },
  }
})
